import { render, staticRenderFns } from "./splashscreen.vue?vue&type=template&id=123acaae"
var script = {}
import style0 from "./splashscreen.vue?vue&type=style&index=0&id=123acaae&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports